module.exports = __webpack_public_path__ + "static/media/noMorePaperWorkIcon.fc59cfc3.svg";